import React from 'react'

const Comment2 = (props) => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.56639 5.50002C2.56639 4.06408 3.73377 2.90002 5.1738 2.90002H18.7123C20.1523 2.90002 21.3197 4.06408 21.3197 5.50002V15C21.3197 16.436 20.1523 17.6 18.7123 17.6H11.3866L5.07351 22.1783V17.5981C3.67996 17.5456 2.56639 16.4025 2.56639 15V5.50002ZM5.1738 4.10002C4.3984 4.10002 3.76981 4.72683 3.76981 5.50002V15C3.76981 15.7732 4.3984 16.4 5.1738 16.4H6.27693V19.8218L10.9952 16.4H18.7123C19.4877 16.4 20.1162 15.7732 20.1162 15V5.50002C20.1162 4.72683 19.4877 4.10002 18.7123 4.10002H5.1738Z"
      fill="#0D1536"
      fillOpacity="0.65"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.208 7.99999H7.17949V6.79999H17.208V7.99999Z"
      fill="#0D1536"
      fillOpacity="0.65"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.208 11H7.17949V9.79999H17.208V11Z"
      fill="#0D1536"
      fillOpacity="0.65"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.208 14H7.17949V12.8H17.208V14Z"
      fill="#0D1536"
      fillOpacity="0.65"
    />
  </svg>
)

export default Comment2
